var cilTablet = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M440,16H80A24.028,24.028,0,0,0,56,40V472a24.028,24.028,0,0,0,24,24H440a24.028,24.028,0,0,0,24-24V40A24.028,24.028,0,0,0,440,16Zm-8,448H88V368H432Zm0-128H88V48H432Z' class='ci-primary'/><rect width='32' height='32' x='232' y='400' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilTablet };

